import { useContext, useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { ArrowRightIcon } from '../../../assets/Icon';
import AuthContext from '../../../contexts/AuthContext';
import useAPI from '../../../hooks/useAPI';
import { UsersEntity } from '../../../lib/types/UserManagement';
import Loader from '../../common/Loader';
import Modal from '../../common/modal/Modal';
import Button from '../../ui/Button';
import TransactionSuccessModal from '../transaction-success-dialog';
import styles from './style.module.scss';

type DeleteUserModalProps = {
  open: boolean;
  onClose: () => void;
  data?: UsersEntity | null;
};

const DeleteUserModal = ({ onClose, open, data }: DeleteUserModalProps) => {
  const [isConfirm, setIsConfirm] = useState(false);
  const [transferId, setTransferId] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const { refetchAdminBalance } = useContext(AuthContext);
  const [error, setError] = useState('');

  const { data: userData, isLoading } = useAPI({
    url: `/auth/users/list?page=1&limit=100000000000000`,
    method: 'GET',
  });
  const { data: selectListData, refetch: refetchDeleteUser } = useAPI({
    url: `/auth/delete/user/select/list?page=1&limit=1000000`,
    method: 'GET',
  });

  const userExits = selectListData?.result?.users
    ?.filter(
      (item: UsersEntity) => item.id !== data?.id && item?.status !== 'PENDING',
    )
    ?.map((item: UsersEntity) => {
      return {
        label:
          item?.firstName && item?.lastName
            ? item?.firstName + ' ' + item?.lastName
            : item?.email.split('@')[0],
        value: item?.id,
      };
    });

  const { refetch, isLoading: isLoadingTransfer } = useAPI({
    url: `/auth/user/delete/${data?.id}`,
    method: 'DELETE',

    onSuccess: data => {
      setSuccessMessage(
        Number(data?.result?.data?.deletedUser?.numberOfToken) &&
          Number(data?.result?.data?.deletedUser?.numberOfToken) > 0
          ? `User deleted and balance tokens ${data?.result?.data?.deletedUser?.numberOfToken} transferred to “ ${data?.result?.data?.transferdUser?.firstName && data?.result?.data?.transferdUser?.lastName ? data?.result?.data?.transferdUser?.firstName + ' ' + data?.result?.data?.transferdUser?.lastName : data?.result?.data?.transferdUser?.email?.split('@')[0]}” successfully!`
          : 'User Deleted Successfully!',
      );
      setIsConfirm(true);
      setTransferId('');
      onClose();
      refetchDeleteUser();
    },
    onError: error => {
      toast.error(error?.response?.data?.message);
    },
    autoFetch: false,
  });

  const handleSubmit = () => {
    if (!data?.numberOfToken || data?.numberOfToken === '0') {
      refetch({
        transferUserId: '',
      });
    } else if (data?.numberOfToken && transferId) {
      refetch({
        transferUserId: transferId,
      });
    } else {
      setError('Please Select Token Transfer User.');
    }
  };
  useEffect(() => {
    if (transferId) {
      setError('');
    } else {
      setError('');
    }
  }, [transferId, open]);
  return (
    <>
      {open &&
        data &&
        (data?.numberOfToken && data?.numberOfToken !== '0' ? (
          <Modal
            open={open}
            onClose={onClose}
            dialogClassName={styles.dialog_content}
            isCloseIconVisible={false}
          >
            <div className={styles.deleteWrapper}>
              <h2 className={styles.title}>
                Do you want to Delete user <br />{' '}
                <span>“{data?.firstName + ' ' + data?.lastName}”</span>?
              </h2>
              <p className={styles.information}>
                Before deleting, please transfer available token to other user
              </p>
              <div className={styles.available_tokens}>
                <div className={styles.available_tokens_item}>
                  <label style={{ margin: '0' }}>Available Tokens</label>
                  <span>{data?.numberOfToken}</span>
                </div>
                <ArrowRightIcon />
                <div className={styles.selectAttributesGroup}>
                  <Form.Group className={styles.selectGroup}>
                    <Form.Label className={styles.selectLabel}>
                      Select User{' '}
                      {data && +data?.numberOfToken > 0 ? (
                        <span className={styles.required}>*</span>
                      ) : (
                        ''
                      )}
                    </Form.Label>
                    <Form.Select
                      className={styles.selectBox}
                      onChange={e => {
                        setTransferId(e?.target?.value);
                      }}
                    >
                      <option>Select User</option>
                      {isLoading ? (
                        <Loader />
                      ) : (
                        userExits?.length > 0 &&
                        userExits?.map((user: any) => (
                          <option value={user?.value}>{user.label}</option>
                        ))
                      )}
                    </Form.Select>
                  </Form.Group>
                  {data?.numberOfToken && (
                    <p className={styles.errors}>{error}</p>
                  )}
                </div>
              </div>
            </div>

            <div className={styles.actions}>
              <Button variant="outline" onClick={onClose}>
                Cancel
              </Button>
              <Button
                variant="dark"
                onClick={() => {
                  handleSubmit();
                }}
                className={styles.delete_btn}
              >
                {isLoadingTransfer && <Loader />}
                Transfer & Delete
              </Button>
            </div>
          </Modal>
        ) : (
          <Modal
            open={open}
            onClose={onClose}
            dialogClassName={styles.dialog_content}
            isCloseIconVisible={false}
          >
            <div className={styles.deleteWrapper}>
              <h2 className={styles.title}>
                Do you want to Delete user <br />{' '}
                <span>“{data?.firstName + ' ' + data?.lastName}”</span>?
              </h2>
            </div>

            <div className={styles.actions}>
              <Button variant="outline" onClick={onClose}>
                Cancel
              </Button>
              <Button
                variant="dark"
                onClick={() => {
                  handleSubmit();
                }}
                className={styles.delete_btn}
              >
                {isLoadingTransfer && <Loader />}
                Delete
              </Button>
            </div>
          </Modal>
        ))}
      <TransactionSuccessModal
        open={isConfirm}
        titleClassName={styles.title}
        title={successMessage}
        isCloseIconVisible={true}
        onClose={() => {
          setIsConfirm(false);
          setSuccessMessage('');
          refetchAdminBalance();
          refetchDeleteUser();
        }}
      />
    </>
  );
};

export default DeleteUserModal;
